"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.REMAINING_BUDGET_LABEL = exports.COMPONENT_IDENTIFIER = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _card = require("../../../../../card");
var _input = require("../../../../../input");
var _collapse = require("../../../../../collapse");
var _CustomLabel = _interopRequireDefault(require("./CustomLabel.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var COMPONENT_IDENTIFIER = exports.COMPONENT_IDENTIFIER = 'budgetLabel';
var REMAINING_BUDGET_LABEL = exports.REMAINING_BUDGET_LABEL = 'remainingBudgetLabel';
var CUSTOM_TITLE_MAX_LENGTH = 30;
var CustomLabel = function CustomLabel(props) {
  var errors = props.errors,
    labels = props.labels,
    rule = props.rule,
    ruleChange = props.ruleChange,
    disabled = props.disabled;
  var customLabel = R.prop(COMPONENT_IDENTIFIER, rule);
  var remainingBudgetLabel = R.prop(REMAINING_BUDGET_LABEL, rule);
  var hasCustomLabel = !R.isNil(customLabel);
  return /*#__PURE__*/_react["default"].createElement(_collapse.Collapse, {
    openItems: hasCustomLabel ? [0] : []
  }, function (_ref) {
    var toggle = _ref.toggle,
      openItems = _ref.openItems;
    return /*#__PURE__*/_react["default"].createElement(_CustomLabel["default"], {
      isOpen: openItems.includes(0)
    }, /*#__PURE__*/_react["default"].createElement(_card.ControlCard, {
      id: "custom-label-card",
      className: "custom-label-card",
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: "custom-label-header"
      }, /*#__PURE__*/_react["default"].createElement("span", null, labels.REMAINING_BUDGET_CUSTOM_LABEL_TITLE)),
      checked: hasCustomLabel,
      onChange: function onChange(_, checked) {
        ruleChange(COMPONENT_IDENTIFIER, checked ? '' : null, REMAINING_BUDGET_LABEL);
        toggle(0);
      },
      disabled: disabled
    }, /*#__PURE__*/_react["default"].createElement(_input.Input, {
      type: "text",
      placeholder: labels.BUDGET_LABEL,
      errors: errors[COMPONENT_IDENTIFIER],
      id: "budgetCustomLabelInput",
      value: customLabel,
      maxLength: CUSTOM_TITLE_MAX_LENGTH,
      onChange: function onChange(event) {
        ruleChange(COMPONENT_IDENTIFIER, event.target.value);
      },
      disabled: disabled
    }), /*#__PURE__*/_react["default"].createElement(_input.Input, {
      type: "text",
      placeholder: labels.REMAINING_BUDGET,
      errors: errors[REMAINING_BUDGET_LABEL],
      id: "remainingBudgetCustomLabelInput",
      value: remainingBudgetLabel,
      maxLength: CUSTOM_TITLE_MAX_LENGTH,
      onChange: function onChange(event) {
        ruleChange(REMAINING_BUDGET_LABEL, event.target.value);
      },
      disabled: disabled
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "custom-label-info"
    }, labels.REMAINING_BUDGET_HELPER_TEXT)));
  });
};
CustomLabel.defaultProps = {
  errors: {},
  disabled: false
};
CustomLabel.propTypes = {
  rule: _propTypes["default"].shape({}).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  errors: _propTypes["default"].shape({}),
  disabled: _propTypes["default"].bool
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(CustomLabel);